module.exports = __webpack_public_path__ + "img/20200907_future_of_law_legal_innovations_in_action_today.9269a574.jpg";